/**
 * Carries a /readiness-check snapshot (saved in localStorage) into the freshly
 * created account, so /welcome can skip the repeat 6-question check.
 * Gated by the features.snapshot_carryover switch (default ON; OFF = old flow).
 */
import axios from "axios";
import { API } from "@/App";
import { isFeatureOn } from "@/lib/siteSettings";

export async function carrySnapshotIfAny() {
  let raw = null;
  try { raw = localStorage.getItem("passadc_snapshot"); } catch { return false; }
  if (!raw) return false;
  if (!(await isFeatureOn("snapshot_carryover"))) return false;
  let snap = null;
  try { snap = JSON.parse(raw); } catch { return false; }
  if (!snap || !snap.scores) return false;
  // Only carry a snapshot the user actually produced just now (freshness guard).
  // A stale/leftover snapshot must NOT tick the new account's readiness checklist item.
  const FRESH_MS = 2 * 60 * 60 * 1000; // 2 hours
  if (!snap.at || (Date.now() - snap.at) > FRESH_MS) {
    try { localStorage.removeItem("passadc_snapshot"); } catch { /* ignore */ }
    return false;
  }
  try {
    await axios.post(
      `${API}/activation/snapshot`,
      { scores: snap.scores, level: snap.level, score_pct: snap.score_pct },
      { withCredentials: true },
    );
    try { localStorage.removeItem("passadc_snapshot"); } catch { /* ignore */ }
    return true;
  } catch {
    return false;
  }
}
